module.exports = __webpack_public_path__ + "img/saum_blau_candy.e23cc487.jpg";